import { navigateTo, patternRoute, simpleRoute } from '../../common/frontend/route-utils.js'
import { t } from '../../common/i18n.js'
import { Spinner } from '../components/spinner/spinner.js'
import { getBaseProps } from '../props/base.js'
import { getSignatureCreationViewProps } from '../props/signatures/index.js'
import { MenuItem, View } from '../types.js'
import { loadSignaturesIfNeeded } from '../utils/load-utils.js'
import { ViewBase } from '../views/base/base.js'
import { SignatureCreationView } from '../views/signaturetool/pages/signature-creation-view/signature-creation-view.js'

class SignatureToolModel {
    // The signature list lives in the profile Signature tab now. The standalone
    // path redirects there; create/edit editor routes stay (reached from the tab).
    public route = simpleRoute<View>('/signaturetool', {
        onEnter: () => {
            navigateTo('/me')
        },
        render: () => <Spinner />,
    })

    public createRoute = patternRoute<View, '/signaturetool/create/:company'>(
        '/signaturetool/create/:company',
        {
            onEnter: (view) => {
                loadSignaturesIfNeeded(view)
            },
            render: (view, params) => {
                const company =
                    params.company === 'play' || params.company === 'nope'
                        ? params.company
                        : undefined
                const props = getSignatureCreationViewProps(view, 'create', undefined, company)
                return (
                    <ViewBase {...getBaseProps(view)}>
                        <SignatureCreationView
                            {...props}
                            view={view}
                            mode="create"
                            company={company}
                        />
                    </ViewBase>
                )
            },
        },
    )

    public editRoute = patternRoute<View, '/signaturetool/edit/:id'>('/signaturetool/edit/:id', {
        onEnter: (view) => {
            loadSignaturesIfNeeded(view)
        },
        render: (view, params) => {
            const props = getSignatureCreationViewProps(view, 'edit', params.id)
            return (
                <ViewBase {...getBaseProps(view)}>
                    <SignatureCreationView
                        {...props}
                        view={view}
                        mode="edit"
                        signatureId={params.id}
                    />
                </ViewBase>
            )
        },
    })

    public menuItem: MenuItem = {
        text: t.signature.menuLabel,
        url: this.route.toUrl(),
        matchingRoutes: [this.route, this.createRoute, this.editRoute],
    }
}

export const signatureToolModel = new SignatureToolModel()
